import React, { useState } from 'react';
import styles from './ManageStartupPage.module.css';
import PropTypes from 'prop-types';

const ManageStartupPageCreateStartupPopup = ({ onClose, onCreate }) => {
  const [newStartup, setNewStartup] = useState({
    startup_name: [''],
    e: { full_name: [''], code: [''] },
    r: { full_name: [''], code: [''] },
  });

  const updateNewStartupListField = (role, field, index, value) => {
    const updated = [...(newStartup[role][field] || [])];
    updated[index] = value;
    setNewStartup((prev) => ({
      ...prev,
      [role]: {
        ...prev[role],
        [field]: updated,
      },
    }));
  };

  const addNewStartupListItem = (role, field) => {
    setNewStartup((prev) => ({
      ...prev,
      [role]: {
        ...prev[role],
        [field]: [...(prev[role][field] || []), ''],
      },
    }));
  };

  const removeNewStartupListItem = (role, field, index) => {
    const updated = [...(newStartup[role][field] || [])];
    updated.splice(index, 1);
    setNewStartup((prev) => ({
      ...prev,
      [role]: {
        ...prev[role],
        [field]: updated,
      },
    }));
  };

  const handleCreateStartup = () => {
    if (onCreate) {
      onCreate(newStartup);
    }
    onClose();
  };

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popup}>
        <h3>Create New Startup</h3>

        <div>
          <label>Startup Name:</label>
          {(newStartup.startup_name || []).map((item, idx) => (
            <div
              key={`shared-startup_name-${idx}`}
              className={styles.listItemRow}
            >
              <input
                className={styles.input}
                type="text"
                value={item}
                onChange={(e) => {
                  const value = e.target.value;
                  const updatedList = [...(newStartup.startup_name || [])];
                  updatedList[idx] = value;
                  setNewStartup((prev) => ({
                    ...prev,
                    startup_name: updatedList,
                  }));
                }}
              />
              <button
                className={styles.removeButton}
                onClick={() => {
                  const updatedList = [...(newStartup.startup_name || [])];
                  updatedList.splice(idx, 1);
                  setNewStartup((prev) => ({
                    ...prev,
                    startup_name: updatedList,
                  }));
                }}
              >
                🗑️
              </button>
            </div>
          ))}
          <button
            className={styles.addButton}
            onClick={() => {
              setNewStartup((prev) => ({
                ...prev,
                startup_name: [...(prev.startup_name || []), ''],
              }));
            }}
          >
            + Add Startup Name
          </button>
        </div>

        {['e', 'r'].map((role) => (
          <div key={role}>
            <h4>Participant {role.toUpperCase()}</h4>

            <div>
              <label>Full Name:</label>
              {(newStartup[role].full_name || []).map((item, idx) => (
                <div
                  key={`${role}-full_name-${idx}`}
                  className={styles.listItemRow}
                >
                  <input
                    className={styles.input}
                    type="text"
                    value={item}
                    onChange={(e) =>
                      updateNewStartupListField(
                        role,
                        'full_name',
                        idx,
                        e.target.value
                      )
                    }
                  />
                  <button
                    className={styles.removeButton}
                    onClick={() =>
                      removeNewStartupListItem(role, 'full_name', idx)
                    }
                  >
                    🗑️
                  </button>
                </div>
              ))}
              <button
                className={styles.addButton}
                onClick={() => addNewStartupListItem(role, 'full_name')}
              >
                + Add Full Name
              </button>
            </div>

            <div>
              <label>Code:</label>
              {(newStartup[role].code || []).map((item, idx) => (
                <div key={`${role}-code-${idx}`} className={styles.listItemRow}>
                  <input
                    className={styles.input}
                    type="text"
                    value={item}
                    onChange={(e) =>
                      updateNewStartupListField(
                        role,
                        'code',
                        idx,
                        e.target.value
                      )
                    }
                  />
                  <button
                    className={styles.removeButton}
                    onClick={() => removeNewStartupListItem(role, 'code', idx)}
                  >
                    🗑️
                  </button>
                </div>
              ))}
              <button
                className={styles.addButton}
                onClick={() => addNewStartupListItem(role, 'code')}
              >
                + Add Code
              </button>
            </div>
          </div>
        ))}

        <div className={styles.buttonGroup}>
          <button className={styles.button} onClick={handleCreateStartup}>
            Submit
          </button>
          <button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

ManageStartupPageCreateStartupPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};

export default ManageStartupPageCreateStartupPopup;
